import ACREAPI from 'utils/services/ACREAPI';

const ENDPOINT_URL_PREFIX = 'newsletter/';

export default class Newsletter {
    static subscribe = ({ email, recaptcha }) => {
        return ACREAPI.guestInstance().post(ENDPOINT_URL_PREFIX + 'subscribe', { email, recaptcha });
    };
}
